import React from 'react';
import moment from 'moment';
import global from '../../../../common/utility/global';
import { FORMAT_2DECIMALS , GREATER_THAN_ZERO} from '../../../../common/types/regularExpresionType';
import { Table, Empty, Button, Input, Form, Select, DatePicker, Icon } from 'antd';
const { Option } = Select;

export default function Cuotas(props) {
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-cuota'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
           

                    {
                        title: 'Couta',
                        dataIndex: 'correlativo',
                        key: 'correlativo',
                        align: 'center',
                        width: '100px',
             
                    },

                    {
                        title: 'Fecha Vencimiento',
                        dataIndex: 'fechaVencimiento',
                        key: 'fechaVencimiento',
                        align: 'center',
                        // width: 120,
                        render:(value)=>moment(value).format("DD-MM-YYYY")

                    },

         

                    {
                        title: 'Monto de Cuota',
                        dataIndex: 'montoCuota',
                        key: 'montoCuota',
                        render:(value)=>parseFloat(value).toFixed(2)

                    },
                    {
                        title: 'Estado',
                        dataIndex: 'estado',
                        key: 'estado',
                    
                    },
                ]}
            />
        </div>
    );
}